// ModalBody.tsx
import React, { useContext } from 'react';
import { ModalVariantContext } from '../../ModalContext';

interface ModalBodyProps {
  children: React.ReactNode;
  noPadding?: boolean;
}

const ModalBody: React.FC<ModalBodyProps> = ({ children, noPadding }) => {
  const variant = useContext(ModalVariantContext);

  const variantClasses = {
    neutral: {
      text: 'text-gray-300',
    },
    warning: {
      text: 'text-indigo-1000',
    },
    dark: {
      text: 'text-gray-300',
    },
  };

  return (
    <div className={`${noPadding ? '' : 'p-4'} overflow-y-auto ${variantClasses[variant].text}`}>
      {children}
    </div>
  );
};

export default ModalBody;
